// FeatureGate — Access-Gate fürs Credits-Modell.
//
// Mit dem Credits-Modell sind ALLE Feature-Bereiche für jeden eingeloggten
// User offen (Nutzung kostet Credits). Einzige Ausnahmen:
//   - `privat` (Docs persönlicher EVE-Modus) → Owner-only, sonst Doc-only-Card.
//   - `admin` → Owner-only, aber das Gating dafür liegt im Router (app.tsx),
//     nicht hier.
//
// Keine Tier-Config mehr — kein „Auf Pro upgraden"-Paywall für offene Features.

import type { ReactNode } from 'react';
import { Lock } from 'lucide-react';
import { useAuth } from '@/hooks/use-auth';
import type { FeatureKey } from '@/types/tier-config';

interface FeatureGateProps {
  feature: FeatureKey;
  children: ReactNode;
  /** Optional eigener Fallback statt der Default-Doc-only-Card (nur `privat`). */
  fallback?: ReactNode;
}

export function FeatureGate({ feature, children, fallback }: FeatureGateProps) {
  const { isOwner } = useAuth();

  // Owner sieht IMMER alles.
  if (isOwner) return <>{children}</>;

  // `privat` bleibt Doc-only — kein Upgrade-Pfad, harte Sperre für Non-Owner.
  if (feature === 'privat') {
    if (fallback !== undefined) return <>{fallback}</>;
    return <DocOnlyCard />;
  }

  // Alle anderen Features sind im Credits-Modell offen für jeden.
  return <>{children}</>;
}

function DocOnlyCard() {
  return (
    <div className="flex h-full items-center justify-center p-6">
      <div className="glass-bar w-full max-w-md rounded-2xl border border-white/10 p-6 text-center">
        <div className="mx-auto mb-4 grid size-12 place-items-center rounded-full bg-amber-500/15 text-amber-300">
          <Lock className="size-6" />
        </div>
        <h2 className="text-lg font-semibold text-white">EVE Private ist gesperrt</h2>
        <p className="mt-2 text-sm text-neutral-400">
          Dieser Modus ist Doc-only (Persönlicher Modus). Kein Upgrade möglich.
        </p>
      </div>
    </div>
  );
}
